<template>
    <b-nav-item @click="layoutType = layoutType === 'vertical' ? 'horizontal' : 'vertical'">
        <font-awesome-icon :icon="currentMenuType" />
    </b-nav-item>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'
import { BNavItem } from 'bootstrap-vue'

export default {
    components: {
        BNavItem,
    },
    computed: {
        currentMenuType() {
            return this.layoutType === 'vertical' ? 'grip-vertical' : 'grip'
        },
    },
    setup() {
        const { layoutType } = useAppConfig()
        return { layoutType }
    },
}
</script>
